"use strict";
// Shared definition for the partner dashboard Toolbox resource PDFs. Lives in aven_types so it can
// be imported by aven_backend (S3 presigning), aven_contracts (API enum), and the partner dashboard
// frontend — one source of truth instead of three copies of the same string literals.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOOLBOX_DOCUMENTS = exports.ToolboxDocument = void 0;
var ToolboxDocument;
(function (ToolboxDocument) {
    ToolboxDocument["atAGlance"] = "at-a-glance";
    ToolboxDocument["trainingGuide"] = "training-guide";
    ToolboxDocument["recastGuide"] = "recast-guide";
    ToolboxDocument["avmDisputeGuide"] = "avm-dispute-guide";
    ToolboxDocument["liveViewGuide"] = "live-view-guide";
    ToolboxDocument["stripeSetUpGuide"] = "stripe-set-up-guide";
    ToolboxDocument["juneReleaseNotes"] = "june-release-notes";
})(ToolboxDocument || (exports.ToolboxDocument = ToolboxDocument = {}));
/**
 * SINGLE SOURCE OF TRUTH for the static Toolbox PDFs.
 *
 * To add a new Toolbox document:
 *   1. Upload the PDF to the private `PARTNER_DASHBOARD_ASSETS_BUCKET` S3 bucket.
 *   2. Add a member to the `ToolboxDocument` enum above.
 *   3. Add its entry here with the matching `s3Key` and a `displayName`.
 * The contract enum, backend presigning, and frontend Toolbox page all derive from this map, so no
 * other file needs to change.
 */
exports.TOOLBOX_DOCUMENTS = {
    [ToolboxDocument.atAGlance]: { s3Key: 'docs/AvenAtAGlance.pdf', displayName: 'Aven At A Glance' },
    [ToolboxDocument.trainingGuide]: { s3Key: 'docs/AvenTrainingGuide.pdf', displayName: 'Aven Training Guide' },
    [ToolboxDocument.recastGuide]: { s3Key: 'docs/AvenRecastGuide.pdf', displayName: 'Aven Recast Guide' },
    [ToolboxDocument.avmDisputeGuide]: { s3Key: 'docs/AvenAVMDisputeGuide.pdf', displayName: 'Aven AVM Dispute Guide' },
    [ToolboxDocument.liveViewGuide]: { s3Key: 'docs/AvenLiveViewGuide.pdf', displayName: 'Aven Live View Guide' },
    [ToolboxDocument.stripeSetUpGuide]: { s3Key: 'docs/AvenStripeSetUpGuide.pdf', displayName: 'Aven Stripe Set Up Guide' },
    [ToolboxDocument.juneReleaseNotes]: { s3Key: 'docs/AvenJuneReleaseNotes.pdf', displayName: 'Aven June Release Notes' },
};
